module.exports = __webpack_public_path__ + "static/media/Sun-18.7ad2aa3e.png";